import getServiceItemIds from 'owa-mail-store/lib/services/utils/getServiceItemIds';
import reportMessageToSafetyLibraryOperation from 'owa-service/lib/operation/reportMessageToSafetyLibraryOperation';
/**
 * Report the message to safety library service
 * @param itemIds the itemIds to update
 * @param safetyApiAction the safetyApiAction type
 * @param actionData the action data
 * @return the ReportMessageToSafetyLibraryResponse
 */
export default function reportMessageToSafetyLibraryService(itemIdsToUpdate, safetyApiAction, actionData) {
    var requestBody = {
        ItemIds: getServiceItemIds(itemIdsToUpdate),
        ReportAction: safetyApiAction,
    };
    if (actionData) {
        requestBody.ActionData = actionData;
    }
    return reportMessageToSafetyLibraryOperation(requestBody).then(function (response) {
        return response.ReportSucccess[0];
    });
}
//# sourceMappingURL=reportMessageToSafetyLibraryService.js.map